import { NavLinks } from '@/components/NavLinks';
import { Layout } from 'antd';
import { FC } from 'react';

const { Sider } = Layout;

type Props = {
  collapsed: boolean;
  onCloseMobileMenu: () => void;
};

const styleBackground = {
  backgroundColor: '#0e0e0fa8',
  backgroundImage: 'radial-gradient(#3b3e5b 1px, #181819 1px)',
  backgroundSize: '20px 20px',
};

export const Sidebar: FC<Props> = ({ collapsed, onCloseMobileMenu }) => {
  return (
    <Sider
      style={styleBackground}
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <NavLinks onCloseMobileMenu={onCloseMobileMenu} />
    </Sider>
  );
};
